import React from "react";
import styles from "./Banner.module.css";
import Typography from "@material-ui/core/Typography";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import IconButton from '@material-ui/core/IconButton';
import {connect} from 'react-redux';
import {logoutUser} from '../../redux/actions/userAction';

const Banner = (props) => {
  return (
    <>
     <div className={styles.bannerWrapper}>
        <Typography varainat="h4" className={styles.bannerText}>
          ABES Enginnering , Ghaziabad
          {props?.authenticated &&<IconButton style={{marginLeft:10,height:10,float: 'right'}} onClick={()=>props.logoutUser()}>
          <ExitToAppIcon />
          </IconButton>}
        </Typography>
        <Typography varainat="h4" className={styles.bannerText}>
          Department of Computer Science and Engineering .
        </Typography>
      </div>
      
    </>
  );
};
const mapActionWithProps = {
  logoutUser,

}

const mapStateWithProps = (state)=>(
  {
    authenticated:state.user.auth
  }
)


export default connect(mapStateWithProps,mapActionWithProps) (Banner);
